import {
  EDraftStatus,
  EDurationType,
  EReasonRejectAcceptance,
  ESocialContent,
  ESocialType
} from "@/modules/helpers/enum"

export const PRICING_OPTS: any = {
  [ESocialType.TIKTOK]: {
    [ESocialContent.VIDEO]: [
      { value: EDurationType.UNDER_60S, label: "Độ dài dưới 60 giây" },
      { value: EDurationType.FROM_1M_TO_3M, label: "Độ dài từ 1 phút đến 3 phút" },
      { value: EDurationType.FROM_4M_TO_10M, label: "Độ dài từ 4 phút tới 10 phút" },
      { value: EDurationType.FROM_11M_TO_15M, label: "Độ dài từ 11 phút đến 15 phút" }
    ],
    [ESocialContent.IMAGE]: [
      { value: EDurationType.TEMPLATE_1_IMAGE, label: "Template 1 hình" },
      { value: EDurationType.CAROUSEL_MAX_10_IMAGES, label: "Carousel tối đa 10 hình" },
      { value: EDurationType.CAROUSEL_11_TO_35_IMAGES, label: "Carousel từ 11 đến 35 hình" }
    ],
    [ESocialContent.STORY]: [{ value: EDurationType.LENGTH_15S, label: "Độ dài 15 giây" }]
  },
  [ESocialType.FACEBOOK]: {
    [ESocialContent.POST]: [
      { value: EDurationType.WITH_IMAGE, label: "Kèm hình" },
      { value: EDurationType.TEXT_ONLY_NO_IMAGE, label: "Chỉ có chữ - KHÔNG kèm hình" }
    ],
    [ESocialContent.VIDEO]: [
      { value: EDurationType.UNDER_60S, label: "Độ dài dưới 60 giây" },
      { value: EDurationType.FROM_1M_TO_3M, label: "Độ dài từ 1 phút đến 3 phút" },
      { value: EDurationType.FROM_3M_ONWARDS, label: "Độ dài từ 3 phút trở lên" }
    ],
    [ESocialContent.STORY]: [
      { value: EDurationType.MAX_15S, label: "Độ dài tối đa 15 giây" },
      { value: EDurationType.MAX_60S, label: "Độ dài tối đa 60 giây" }
    ]
  },
  [ESocialType.INSTAGRAM]: {
    [ESocialContent.POST]: [
      { value: EDurationType.ONE_IMAGE, label: "1 hình" },
      { value: EDurationType.MAX_10_IMAGES, label: "Tối đa 10 hình/ post" }
    ],
    [ESocialContent.STORY]: [{ value: EDurationType.MAX_60S, label: "Tối đa 60 giây" }],
    [ESocialContent.REEL]: [{ value: EDurationType.MAX_90S, label: "Tối đa 90 giây" }]
  },
  [ESocialType.YOUTUBE]: {
    [ESocialContent.VIDEO]: [
      { value: EDurationType.UNDER_60S, label: "Độ dài dưới 60 giây" },
      { value: EDurationType.FROM_1M_TO_10M, label: "Độ dài từ 1 phút đến 10 phút" },
      { value: EDurationType.FROM_11M_TO_30M, label: "Độ dài từ 11 phút đến 30 phút" },
      { value: EDurationType.FROM_30M_ONWARDS, label: "Độ dài từ 30 phút trở lên" }
    ]
  }
}

export const SOCIAL_CONTENT_LABEL: Record<string, string> = {
  [ESocialContent.POST]: "Bài đăng",
  [ESocialContent.VIDEO]: "Video",
  [ESocialContent.IMAGE]: "Hình ảnh",
  [ESocialContent.REEL]: "Reel",
  [ESocialContent.STORY]: "Story",
  [ESocialContent.LIVESTREAM]: "Livestream"
}

export const TEXT_STATUS_DRAFT: Record<string, string> = {
  [EDraftStatus.FINALIZED]: "Đã chấp nhận",
  [EDraftStatus.REVIEWED]: "Nhãn hàng từ chối",
  [EDraftStatus.WAITING]: "Chờ xét duyệt",
  [EDraftStatus.DRAFT]: "Chờ xét duyệt",
  [EDraftStatus.APPROVED]: "Đã chấp nhận",
  [EDraftStatus.REJECTED]: "Nhãn hàng từ chối",
  [EDraftStatus.ACCEPTED_ACCEPTANCE]: "Đã nghiệm thu",
  [EDraftStatus.REJECTED_ACCEPTANCE]: "Đã từ chối nghiệm thu"
}

export const TEXT_STATUS_DRAFT_COLOR: Record<string, string> = {
  [EDraftStatus.FINALIZED]:
    "bg-green-200/30 text-green-600 rounded-full ml-2 px-2 py-0.5 border border-green-600 text-xss font-medium ",
  [EDraftStatus.REVIEWED]:
    "bg-red-200/30 text-red-600 rounded-full  ml-2 px-2 py-0.5 border border-red-600 text-xss font-medium",
  [EDraftStatus.WAITING]:
    "bg-yellow-200/30 text-yellow-600 rounded-full  ml-2 px-2 py-0.5 border border-yellow-600 text-xss font-medium",
  [EDraftStatus.DRAFT]:
    "bg-yellow-200/30 text-yellow-600 rounded-full  ml-2 px-2 py-0.5 border border-yellow-600 text-xss font-medium",
  [EDraftStatus.APPROVED]:
    "bg-green-200/30 text-green-600 rounded-full  ml-2 px-2 py-0.5 border border-green-600 text-xss font-medium",
  [EDraftStatus.REJECTED]:
    "bg-red-200/30 text-red-600 rounded-full ml-2 px-2 py-0.5 border border-red-600 text-xss font-medium",
  [EDraftStatus.ACCEPTED_ACCEPTANCE]:
    "bg-green-200/30 text-green-600 rounded-full  ml-2 px-2 py-0.5 border border-green-600 text-xss font-medium",
  [EDraftStatus.REJECTED_ACCEPTANCE]:
    "bg-red-200/30 text-red-600 rounded-full ml-2 px-2 py-0.5 border border-red-600 text-xss font-medium"
}

export const REASON_REJECT_ACCEPTANCE_MESSAGE: Record<string, string> = {
  [EReasonRejectAcceptance.VIDEO_IS_LATE]: "Bài đăng trễ hạn",
  [EReasonRejectAcceptance.VIDEO_IS_WRONG_LINK]: "Gắn sai link bài đăng",
  [EReasonRejectAcceptance.VIDEO_IS_NOT_ATTACH_SHOP_CART]: "Video không gắn giỏ hàng",
  [EReasonRejectAcceptance.VIDEO_IS_ATTACH_WRONG_SHOP_CART]: "Video gắn sai giỏ hàng"
}
